import $ from 'jquery';
export default function Group() {
    document.querySelectorAll('.wp-block-button.is-style-has-icon-end').forEach((button) => {
        button.addEventListener('click', (e) => {
            const parent = button.closest('.wp-block-buttons');

            const buttonLink = button.querySelector('.wp-block-button__link')

            const expandContainer = parent.previousElementSibling;

            if(expandContainer && expandContainer.classList.contains('is-style-expand-content')) {
                e.preventDefault();

                expandContainer.classList.toggle('is-expanded');
                $(expandContainer).slideToggle();

                button.classList.toggle('is-expanded');
                buttonLink.innerHTML = buttonLink.innerHTML === 'Less' ? 'Read more' : 'Less';
            }
        });
    });
}
